// Utility for traffic configurability logic for modals

import { setCookie } from '@directv-digital/dds.services.cookie-service';

export interface TrafficConfigOptions {
  trafficDistributionPercentage?: any;
  groupKey: string;
  distributionKey: string;
  analyticsCookieKey?: string;
}

const analyticsCookieValueMappings: Record<string, Record<'A' | 'B', string>> = {
  showRevisitorModalGroup: {
    A: 'resumecart_true',
    B: 'resumecart_false'
  },
  // showSessionAIModalGroup: { A: 'aimodal_true', B: 'aimodal_false' }, // dummies for session AI and exit modal
  showExitModalMouseLeaveGroup: {
    A: 'exitmodal_exit_true',
    B: 'exitmodal_exit_false'
  },
  showExitModalIdleGroup: {
    A: 'exitmodal_idle_true',
    B: 'exitmodal_idle_false'
  },
  showExitModalPageLoadGroup: {
    A: 'exitmodal_visit_true',
    B: 'exitmodal_visit_false'
  }
};

export function getTrafficGroup({
  trafficDistributionPercentage,
  groupKey,
  distributionKey,
  analyticsCookieKey
}: TrafficConfigOptions): 'A' | 'B' {
  const parseOptionToPercent = (val: any): number => {
    // eslint-disable-next-line curly
    if (val === undefined || val === null || val === "") return 100;
    const n = val?.toString()?.trim()?.toLowerCase();
    // eslint-disable-next-line curly
    if (n === "off") return 0;
    const numeric = parseFloat(n?.replace("%", ""));
    // eslint-disable-next-line curly
    if (!isNaN(numeric) && numeric >= 0 && numeric <= 100) return numeric;
    return 100; // fallback
  };

  const distributionPercentage = parseOptionToPercent(trafficDistributionPercentage);
  const probabilityOfA = distributionPercentage / 100;

  const storedGroup = window.sessionStorage.getItem(groupKey);
  const storedDist = window.sessionStorage.getItem(distributionKey);
  let modalGroup: 'A' | 'B';

  if (!storedGroup || storedDist !== distributionPercentage.toString()) {
    if (distributionPercentage === 0) {
      modalGroup = "B";
    } else if (distributionPercentage === 100) {
      modalGroup = "A";
    } else {
      const rand = Math.random();
      modalGroup = rand <= probabilityOfA ? "A" : "B";
      // console.log("groupKey==>", groupKey, "rand", rand, "probA", probabilityOfA, "assigned", modalGroup);
    }
    const valueMap = analyticsCookieValueMappings[groupKey] || {};
    const analyticsCookieValue = valueMap[modalGroup] || null;
    setCookie(groupKey, modalGroup);
    analyticsCookieKey && analyticsCookieValue && setCookie(analyticsCookieKey, analyticsCookieValue);
    window.sessionStorage.setItem(groupKey, modalGroup);
    window.sessionStorage.setItem(distributionKey, distributionPercentage?.toString());
  } else {
    modalGroup = storedGroup as 'A' | 'B';
  }
  return modalGroup;
}
